function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "logo",
  transform: "translate(3.045 2.974)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11701",
  "data-name": "Path 11701",
  d: "M-1066.382-287.023l-27.075-18.156,27.075-29.623,26.757,29.623Z",
  transform: "translate(1093.457 334.802)",
  fill: "none",
  stroke: "#ac1ede",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11702",
  "data-name": "Path 11702",
  d: "M-1083.652-334.8v47.46",
  transform: "translate(1110.568 334.802)",
  fill: "none",
  stroke: "#ac1ede",
  strokeWidth: 4
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59.901,
    height: 53.165,
    viewBox: "0 0 59.901 53.165",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.20d692dd.svg";
export { ForwardRef as ReactComponent };